export var UploadSurplusItemsStepIndex;
(function (UploadSurplusItemsStepIndex) {
    UploadSurplusItemsStepIndex[UploadSurplusItemsStepIndex["StockSelect"] = 0] = "StockSelect";
    UploadSurplusItemsStepIndex[UploadSurplusItemsStepIndex["FileUpload"] = 1] = "FileUpload";
    UploadSurplusItemsStepIndex[UploadSurplusItemsStepIndex["CellMapping"] = 2] = "CellMapping";
    UploadSurplusItemsStepIndex[UploadSurplusItemsStepIndex["PriceSearch"] = 3] = "PriceSearch";
})(UploadSurplusItemsStepIndex || (UploadSurplusItemsStepIndex = {}));
